module.exports = __webpack_public_path__ + "static/media/ian_elliott.3e975adb.jpg";